/**
 * Was das Gerät über sich verrät — an einer Stelle statt in jeder Ansicht.
 *
 * „Schmal" ist eine Frage an den Bildschirm, nicht an das Gerät: Ein schmales
 * Fenster auf dem Schreibtisch bekommt dieselbe Bedienung wie ein Telefon. Die
 * Schwelle ist 46rem, dieselbe Zahl wie beim Verorten, das den Umbruch als
 * erste Ansicht gebraucht hat.
 *
 * **Ein Telefon quer bekam bis dahin die breite Bedienung** — 915 Pixel sind
 * eben nicht schmal. Das Ergebnis war die Schreibtisch-Ansicht auf einem
 * Handteller: acht Reiter nebeneinander statt der Tab-Leiste, keine
 * Kopfzeile zum Zurückgehen, Spaltenbreiten für einen Bildschirm in
 * siebzig Zentimetern Abstand. Wer das Telefon dreht, will keine andere App.
 *
 * Deshalb eine zweite Bedingung daneben, als ODER: flach **und** mit dem
 * Finger bedient. 30rem (480 Pixel) liegt über jedem Telefon quer (375 bis
 * 430) und unter jedem Tablet (768). `pointer: coarse` hält ein flaches
 * Fenster am Schreibtisch heraus — dort ist die breite Bedienung richtig.
 *
 * Die Zeile steht wortgleich in `style.css`, an allen drei Blöcken. Wer sie
 * hier ändert, ändert sie dort.
 */

export const UMBRUCH = '(max-width: 46rem), (max-height: 30rem) and (pointer: coarse)';
const GROB = '(pointer: coarse)';

function frage(bedingung) {
  return globalThis.matchMedia?.(bedingung) ?? { matches: false, addEventListener() {} };
}

export function istSchmal() {
  return frage(UMBRUCH).matches;
}

/** Wird mit dem Finger bedient? Entscheidet über Langdruck und Gesten. */
export function istGrob() {
  return frage(GROB).matches;
}

/** Meldet jeden Wechsel der Breite — die Hülle baut ihre Leisten dann neu. */
export function beiUmbruch(rueckruf) {
  const anfrage = frage(UMBRUCH);
  const behandle = () => rueckruf(anfrage.matches);
  anfrage.addEventListener?.('change', behandle);
  return () => anfrage.removeEventListener?.('change', behandle);
}

/**
 * Ein kurzer Stups.
 *
 * Nur Android kann das; iOS ignoriert `vibrate` stillschweigend, und das ist
 * in Ordnung — die Rückmeldung ist eine Zugabe, keine Auskunft. Wer weniger
 * Bewegung eingestellt hat, will auch das nicht.
 */
export function stups(dauer = 12) {
  if (globalThis.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;
  try {
    globalThis.navigator?.vibrate?.(dauer);
  } catch {
    // Manche Browser werfen, wenn die Seite nicht im Vordergrund ist.
  }
}

/** Läuft die App als installierte App und nicht im Browser-Reiter? */
export function istInstalliert() {
  return frage('(display-mode: standalone)').matches
    || globalThis.navigator?.standalone === true;
}
